var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridViewGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #606060;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9796",
    "data-name": "Group 9796",
    transform: "translate(-1413.902 -542.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_7007",
    "data-name": "Path 7007",
    className: "cls-1",
    transform: "translate(1411.903 540.545)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.407,10H2.593A.593.593,0,0,1,2,9.407V2.593A.593.593,0,0,1,2.593,2H9.407A.593.593,0,0,1,10,2.593V9.407A.593.593,0,0,1,9.407,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 8 8 L 8 4 L 4.000000476837158 4 L 4.000000476837158 8 L 8 8 M 9.40725040435791 10 L 2.592750549316406 10 C 2.265960454940796 10 2.000000476837158 9.734129905700684 2.000000476837158 9.40725040435791 L 2.000000476837158 2.592750072479248 C 2.000000476837158 2.265870094299316 2.265960454940796 2 2.592750549316406 2 L 9.40725040435791 2 C 9.734040260314941 2 10 2.265870094299316 10 2.592750072479248 L 10 9.40725040435791 C 10 9.734129905700684 9.734040260314941 10 9.40725040435791 10 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7055",
    "data-name": "Path 7055",
    className: "cls-1",
    transform: "translate(1421.903 540.545)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.407,10H2.593A.593.593,0,0,1,2,9.407V2.593A.593.593,0,0,1,2.593,2H9.407A.593.593,0,0,1,10,2.593V9.407A.593.593,0,0,1,9.407,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 8 8 L 8 4 L 4.000000476837158 4 L 4.000000476837158 8 L 8 8 M 9.40725040435791 10 L 2.592750549316406 10 C 2.265960454940796 10 2.000000476837158 9.734129905700684 2.000000476837158 9.40725040435791 L 2.000000476837158 2.592750072479248 C 2.000000476837158 2.265870094299316 2.265960454940796 2 2.592750549316406 2 L 9.40725040435791 2 C 9.734040260314941 2 10 2.265870094299316 10 2.592750072479248 L 10 9.40725040435791 C 10 9.734129905700684 9.734040260314941 10 9.40725040435791 10 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7056",
    "data-name": "Path 7056",
    className: "cls-1",
    transform: "translate(1411.903 550.545)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.407,10H2.593A.593.593,0,0,1,2,9.407V2.593A.593.593,0,0,1,2.593,2H9.407A.593.593,0,0,1,10,2.593V9.407A.593.593,0,0,1,9.407,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 8 8 L 8 4 L 4.000000476837158 4 L 4.000000476837158 8 L 8 8 M 9.40725040435791 10 L 2.592750549316406 10 C 2.265960454940796 10 2.000000476837158 9.734129905700684 2.000000476837158 9.40725040435791 L 2.000000476837158 2.592750072479248 C 2.000000476837158 2.265870094299316 2.265960454940796 2 2.592750549316406 2 L 9.40725040435791 2 C 9.734040260314941 2 10 2.265870094299316 10 2.592750072479248 L 10 9.40725040435791 C 10 9.734129905700684 9.734040260314941 10 9.40725040435791 10 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_7057",
    "data-name": "Path 7057",
    className: "cls-1",
    transform: "translate(1421.903 550.545)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.407,10H2.593A.593.593,0,0,1,2,9.407V2.593A.593.593,0,0,1,2.593,2H9.407A.593.593,0,0,1,10,2.593V9.407A.593.593,0,0,1,9.407,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M 8 8 L 8 4 L 4.000000476837158 4 L 4.000000476837158 8 L 8 8 M 9.40725040435791 10 L 2.592750549316406 10 C 2.265960454940796 10 2.000000476837158 9.734129905700684 2.000000476837158 9.40725040435791 L 2.000000476837158 2.592750072479248 C 2.000000476837158 2.265870094299316 2.265960454940796 2 2.592750549316406 2 L 9.40725040435791 2 C 9.734040260314941 2 10 2.265870094299316 10 2.592750072479248 L 10 9.40725040435791 C 10 9.734129905700684 9.734040260314941 10 9.40725040435791 10 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewGray);
export default __webpack_public_path__ + "static/media/GridViewGray.082b8bfe63e3047d4ee29ffbe49933f7.svg";
export { ForwardRef as ReactComponent };